

const SettingReducer = (state, action) => {
    switch (action.type) {
        case "GET_SETTINGS_START":
            return {
                ...state,
                settings: {},
                isFetchingGet: true,
                errorGet: false,
            };
        case "GET_SETTINGS_SUCCESS":
            return {
                ...state,
                settings: action.payload.settings,
                isFetchingGet: false,
                errorGet: false,
            };
        case "GET_SETTINGS_FAILURE":
            return {
                ...state,
                settings: {},
                isFetchingGet: false,
                errorGet: action.payload,
            };
        case "UPDATE_SETTINGS_START":
            return {
                ...state,
                message: "",
                isFetchingUpdate: true,
                errorUpdate: false,
            };
        case "UPDATE_SETTINGS_SUCCESS":
            return {
                ...state,
                message: action.payload.message,
                isFetchingUpdate: false,
                errorUpdate: false,
            };
        case "UPDATE_SETTINGS_FAILURE":
            return {
                ...state,
                message: "",
                isFetchingUpdate: false,
                errorUpdate: action.payload,
            };
        case "CLEAR_SETTINGS":
            return {
                ...state,
                message: "",
                settings: {},
            };
        default:
            return { ...state };
    }
}

export default SettingReducer;